import { cn } from "@/utils/cn";

const VARIANTS = {
  glow: "btn-glow",
  outline: "btn-outline font-semibold",
};

const SIZES = {
  sm: "px-4 py-2 text-xs",
  md: "px-5 py-2.5 text-sm",
  lg: "px-7 py-4 text-base",
};

// Reusable button. Renders an <a> when `href` is passed, otherwise a <button>.
export const Button = ({
  variant = "glow",
  size = "md",
  as,
  className = "",
  children,
  ...props
}) => {
  const Tag = as || (props.href ? "a" : "button");
  return (
    <Tag
      className={cn(
        VARIANTS[variant],
        SIZES[size],
        "uppercase tracking-wider inline-flex items-center justify-center gap-2",
        className
      )}
      {...props}
    >
      {children}
    </Tag>
  );
};
